<div class="ga4-events-log">
  <button class="ga4-events-log__btn"
          mat-mini-fab
          matSuffix
          (click)="toggle()">
    <mat-icon>analytics</mat-icon>
  </button>

  <div *ngIf="expanded"
       class="ga4-events-log__content">

    <div class="ga4-events-log__content__header">
      <button class="ga4-events-log__content__header__clear-btn"
              mat-icon-button
              matSuffix
              (click)="clear()">
        <mat-icon>delete</mat-icon>
      </button>

      <div *ngIf="stateService.analyticsUserId"
           class="ga4-events-log-payload ga4-events-log-payload--highlighted">
        <span class="ga4-events-log-payload__name">user_id</span>: {{ stateService.analyticsUserId }}
      </div>

<!--      <div *ngIf="stateService.analyticsClientId"-->
<!--           class="ga4-events-log-payload ga4-events-log-payload&#45;&#45;highlighted">-->
<!--        <span class="ga4-events-log-payload__name">client_id</span>: {{ stateService.analyticsClientId }}-->
<!--      </div>-->
    </div>

    <div class="ga4-events-log__content__events"
          #eventsContainer
         [scrollTop]="eventsContainer.scrollHeight">
      <ng-container *ngFor="let event of googleAnalyticsService.debugData; let i = index">
        <div class="ga4-events-log__event">
          <div class="ga4-events-log__event__title">
            #{{ i + 1 }} {{ event.eventKey }} | <span class="ga4-events-log__event__title__name">{{ getEventName(event) }}</span>
          </div>
          <div class="ga4-events-log__event__payload">
            <div *ngFor="let item of getPayloadProps(event)"
                 class="ga4-events-log-payload"
                 [ngClass]="{'ga4-events-log-payload--highlighted': isPropertyHighlighted(item.propertyName)}">
              <span class="ga4-events-log-payload__name">{{ item.propertyName }}</span>: {{ item.value }}
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
